import "@/App.css";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/landing/SmoothScroll";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Manifesto from "@/components/landing/Manifesto";
import Personas from "@/components/landing/Personas";
import ToolStack from "@/components/landing/ToolStack";
import Playbook from "@/components/landing/Playbook";
import Pricing from "@/components/landing/Pricing";
import FAQ from "@/components/landing/FAQ";
import ContactForm from "@/components/landing/ContactForm";
import Footer from "@/components/landing/Footer";

function App() {
    return (
        <div className="App grain" data-testid="app-root">
            <SmoothScroll />
            <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#0c0c0c",
                        border: "1px solid rgba(255,255,255,0.1)",
                        color: "#fff",
                        fontFamily: "JetBrains Mono, monospace",
                        fontSize: "0.75rem",
                        letterSpacing: "0.1em",
                        textTransform: "uppercase",
                        borderRadius: 0,
                    },
                }}
            />
            <Nav />
            <main>
                <Hero />
                <Marquee />
                <Manifesto />
                <Personas />
                <ToolStack />
                <Playbook />
                <Pricing />
                <FAQ />
                <ContactForm />
            </main>
            <Footer />
        </div>
    );
}

export default App;
